import React from "react";
import { motion } from "framer-motion";

const PageHero = ({ eyebrow, title, intro, introExtra, image, testid = "page-hero" }) => (
  <section className="relative pt-36 pb-20 overflow-hidden" data-testid={testid}>
    {image && (
      <>
        <motion.img
          src={image}
          alt=""
          initial={{ scale: 1.12 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0C10]/70 via-[#0B0C10]/80 to-[#0B0C10]" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      {eyebrow && (
        <motion.p
          className="eyebrow mb-5"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          {eyebrow}
        </motion.p>
      )}
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#F4F3EF] leading-[1.08] max-w-4xl">
        <span className="mask-line">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.span>
        </span>
      </h1>
      {intro && (
        <motion.p
          className="text-lg text-[#9DA3AE] font-light leading-relaxed max-w-2xl mt-7"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          {intro}
        </motion.p>
      )}
      {introExtra && (
        <motion.p
          className="text-base text-[#9DA3AE] font-light leading-relaxed max-w-2xl mt-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.65 }}
        >
          {introExtra}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHero;
